import React, { useEffect, useState } from 'react'
import { FaDownload, FaFacebookF, FaSms, FaTwitter } from 'react-icons/fa'
import { FiInstagram, FiMail } from 'react-icons/fi'
import { IoLogoLinkedin } from 'react-icons/io5'
import logoThree from '../../../../assets/images/logo/Haylo-logo-white.png'
import parse from 'html-react-parser'

function TemplateThree(props) {

  const initialState = {
    logo: logoThree,
    contentBodyText: "Share now with your family and friends",
    SocialMenuStyle: "#CEA252",
    buttonText: "Gallery",
    buttonColor: `rgb(206, 162, 82)`,
    footerText: `Brought you by <a href="#">The Haylo</a>`,
  }
  const [socailShareContent, setContent] = useState({ ...initialState })

  const [selectedState, setSelectedState] = useState(null)

  const selectElement = (stateName, theValue) => {
    props.setChangeState(stateName, theValue)

    setSelectedState(stateName)

  }

  useEffect(() => {
    if (props.changeStateData !== socailShareContent[`${selectedState}`]) {
      if(props.changeStateData != ''){
        let content = { ...socailShareContent, [`${selectedState}`]: props.changeStateData }
        setContent(content)
        props.copyEditedData(content)
      }
    }

    if (props.reset === true) {
      setContent({ ...initialState })
    }

  }, [props])


  return (
    <div className="Customer-microsite-default">

            <div className="header default-header">
              <div className="container">
                <div className="row">
                  <div className="col">
                    <div className="header-image text-center py-4">
                      {
                        socailShareContent.logo &&
                        <img src={socailShareContent.logo} onClick={e => selectElement('logo', socailShareContent.logo)} className="img-fluid" alt="logo" style={{ width: "250px" }} />
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="main-body mt-5">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-md-12">
                    <div className="gallery-item-view text-center">
                        <div className="gallery-image text-center">
                          <img src="https://img.freepik.com/free-photo/groom-black-tuxedo-hugs-tender-stunning-bride-while-they-stand_8353-8050.jpg?size=626&ext=jpg" alt="random-photos" className="img-fluid img-thumbnail h-100" />
                        </div>

                      <p className="tag-line py-4" onClick={e => selectElement('contentBodyText', socailShareContent.contentBodyText)}>{parse(socailShareContent.contentBodyText)}</p>

                      <ul className="share-option" onClick={e => selectElement('SocialMenuStyle', socailShareContent.SocialMenuStyle)}>
                        <li>
                          <a href="#" style={{background: socailShareContent.SocialMenuStyle}}><FiMail size={20} /></a>
                        </li>
                        <li>
                          <a href="#" style={{background: socailShareContent.SocialMenuStyle}}><FaSms size={20} /></a>
                        </li>
                        <li>
                          <a href="#" style={{background: socailShareContent.SocialMenuStyle}}><FaFacebookF size={20} /></a>
                        </li>
                        <li>
                          <a href="#" style={{background: socailShareContent.SocialMenuStyle}}><FaTwitter size={20} /></a>
                        </li>
                        <li>
                          <a href="#" style={{background: socailShareContent.SocialMenuStyle}}><IoLogoLinkedin size={20} /></a>
                        </li>
                        <li>
                          <a href="#" style={{background: socailShareContent.SocialMenuStyle}}><FiInstagram size={20} /></a>
                        </li>
                        <li>
                          <a href="#" style={{background: socailShareContent.SocialMenuStyle}}><FaDownload size={20} /></a>
                        </li>
                      </ul>

                      <a href="#" className="back-to-gallery" onClick={e => selectElement('buttonText', socailShareContent.buttonText)}>{parse(socailShareContent.buttonText)}</a>

                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="micro-site-footer">
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <p className="text-center footer-name" onClick={e=> selectElement('footerText', socailShareContent.footerText)}>{parse(socailShareContent.footerText)}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
  )
}

export default TemplateThree
